<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.artifact'),

            filter: {
                title: { value: null, type: 'text'},
                user_id: { value: null, type: 'text'},
                country_id: { value: null, type: 'select', options: [] },
                is_published: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
                is_inspiration: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
                is_main: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
                is_old_is_it: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
                is_origin_year: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'image', is_sort: false, },
                { key: 'title', is_sort: true, classes: 'text-l wrap' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'country_id', is_sort: true, classes: 'text-l wrap' },
                { key: 'is_published', is_sort: true, classes: 'text-l' },
                { key: 'is_inspiration', is_sort: true, classes: 'text-l' },
                { key: 'is_main', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                image: { type: 'function', function: this.getImage },
                country_id: { type: 'function', function: this.getCountries },
                user_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'user_id',
                    label: 'name',
                    dictionary: 'user_id'
                },
                is_published: { type: 'boolean' },
                is_inspiration: { type: 'boolean' },
                is_main: { type: 'boolean' },
            },

            apiList: this.$store.getters.getApiUrl('artifact'),
            pageRoute: 'artifact',
            pageRouteCreate: 'artifact.create',
            pageRouteEdit: 'artifact.edit',
            pagePermission: 'artifact.items',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    },
    methods: {
        getCountries(item) {
            let countries = []
            item.countries.map(i => {
                countries.push(i.title)
            })
            return countries.join(', ')
        },
        getImage(item) {
            let image = item.preview_url_cdn_query
            if (!item.preview_url_cdn_query) {
                image = '/images/no_image.png'
            }
            if (!item.is_published) {
                image = '/images/no_image.png'
            }
            return '<img class="image-cover" style="background-image: url('+image+')">'
        }
    }
}
</script>

<style scoped>

</style>
